import { render, staticRenderFns } from "./FormulaQnaWrite.vue?vue&type=template&id=211909b0"
import script from "./FormulaQnaWrite.vue?vue&type=script&lang=js"
export * from "./FormulaQnaWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports